import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { listPaymentOrders, listUserPaymentOrders } from '../../api/paymentOrder';

// 支付类型映射
export const PAYMENT_TYPE_MAP = {
  1: '商品购买',
  2: '充值',
  3: '提现',
  4: '服务购买',
  5: '其他'
};

// 支付渠道映射
export const PAYMENT_CHANNEL_MAP = {
  ALIPAY: '支付宝',
  WECHAT: '微信支付',
  UNIONPAY: '银联',
  BANK_CARD: '银行卡',
  BALANCE: '余额支付',
  OTHER: '其他'
};

// 支付状态映射
export const PAYMENT_STATUS_MAP = {
  0: '待支付',
  1: '支付成功',
  2: '支付失败',
  3: '已退款',
  4: '部分退款',
  5: '已取消',
  6: '已超时'
};

// 分页查询支付订单的异步 thunk
export const fetchPaymentOrders = createAsyncThunk(
  'paymentOrder/fetchPaymentOrders',
  async (params, { rejectWithValue }) => {
    try {
      const response = await listPaymentOrders(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// 查询指定用户支付订单的异步 thunk
export const fetchUserPaymentOrders = createAsyncThunk(
  'paymentOrder/fetchUserPaymentOrders',
  async ({ userId, page, pageSize }, { rejectWithValue }) => {
    try {
      const response = await listUserPaymentOrders(userId, page, pageSize);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const paymentOrderSlice = createSlice({
  name: 'paymentOrder',
  initialState: {
    orders: [],
    total: 0,
    current: 1,
    pageSize: 10,
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    // 处理分页查询支付订单的 reducer
    builder.addCase(fetchPaymentOrders.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchPaymentOrders.fulfilled, (state, action) => {
      state.loading = false;
      state.orders = action.payload.records;
      state.total = action.payload.total;
      state.current = action.payload.current;
      state.pageSize = action.payload.size;
    });
    builder.addCase(fetchPaymentOrders.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // 处理查询指定用户支付订单的 reducer
    builder.addCase(fetchUserPaymentOrders.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchUserPaymentOrders.fulfilled, (state, action) => {
      state.loading = false;
      state.orders = action.payload.records;
      state.total = action.payload.total;
      state.current = action.payload.current;
      state.pageSize = action.payload.size;
    });
    builder.addCase(fetchUserPaymentOrders.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  }
});

export default paymentOrderSlice.reducer;
